import { mapGetters, mapActions } from 'vuex'
import manuscript from '../../../api/manuscript'

const stepList = [
  {
    index: 1,
    icon: 'iconManuscript',
    name: 'Manuscript Information',
    href: '/step1'
  },
  {
    index: 2,
    icon: 'iconAuthor',
    name: 'Author Information',
    href: '/step2'
  },
  {
    index: 3,
    icon: 'icona-UploadDoc',
    name: 'Upload Documents',
    href: '/step3'
  },
  {
    index: 4,
    icon: 'iconSuggest',
    name: 'Suggested & Opposed Reviewers',
    href: '/step4'
  },
  {
    index: 5,
    icon: 'iconConfirmation',
    name: 'Confirmation & Submission',
    href: '/step5'
  }
]

export default {
  data() {
    return {
      isVisable: false,
      dataSource: [],
      firstPath: '/author/submit-manuscripts',
      stepList,
      path: '',
      params: {
        released: ''
      },
      id: ''
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      manuscript: 'getManuscript',
      domain: 'getDomain'
    })
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route: {
      handler(val) {
        this.path = val.path
        this.getQuery(val.query.id)
        if (this.path.includes('/editorial-office')) {
          this.firstPath = '/editorial-office/manuscripts/submit-manuscripts'
        } else {
          this.firstPath = '/author/submit-manuscripts'
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    ...mapActions(['updateManuscript']),
    async getQuery(id) {
      if (!id && !this.$route.path.includes('step1')) {
        this.$router.push('/author/submit-manuscripts/step1')
        return
      } else if (!id) {
        this.updateManuscript({})
        return
      }
      this.id = id
      if (!this.manuscript.id || this.manuscript.id !== id) {
        this.updateManuscript(await manuscript.query(id))
      }
    }
  }
}
